import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  <path
    d='M14.5,2.5c0,1.5-1.5,6-1.5,6h-2c0,0-1.5-4.5-1.5-6C9.5,1.1,10.6,0,12,0S14.5,1.1,14.5,2.5z M12,10c-1.1,0-2,0.9-2,2
	s0.9,2,2,2s2-0.9,2-2S13.1,10,12,10z M16.1,5.1c0.2-0.8,0.3-1.5,0.4-2.1c3.3,1.6,5.5,5,5.5,8.9c0,5.5-4.5,10-10,10S2,17.5,2,12
	c0-3.9,2.2-7.3,5.5-8.9c0.1,0.6,0.2,1.3,0.4,2.1C5.6,6.5,4,9.1,4,12c0,4.4,3.6,8,8,8s8-3.6,8-8C20,9.1,18.4,6.5,16.1,5.1z M18,12
	c0,3.3-2.7,6-6,6s-6-2.7-6-6c0-2,1-3.8,2.5-4.9c0.2,0.8,0.6,2.1,0.6,2.1C8.4,9.9,8,10.9,8,12c0,2.2,1.8,4,4,4s4-1.8,4-4
	c0-1.1-0.4-2.1-1.1-2.8c0,0,0.4-1.2,0.6-2.1C17,8.2,18,10,18,12z'
  />,
  'TransportMarker'
);

const TransportMarkerAlarmIcon = function (props) {
  return <SvgIcon xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' {...props} stroke='#FFFFFF' />;
};

export default memo(TransportMarkerAlarmIcon);
